import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-menu',
    templateUrl: '../svgs/Menu.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--menu'
    }
})
export class TellerOnlineIconMenu {
}